import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './MedicosConsultas.css';
import { ReactComponent as Horaicon } from "../Assets/hora.svg";
import { ReactComponent as NoProfileIcon } from "../Assets/padrao.svg";
import ConsultaSelectionModal from "../ConsultaSelectionModal/ConsultaSelectionModal";
import AgendarConsultaModal from "../../Pages/AgendarConsultaModal";
import clinicaConfig from "../../clinicaConfig.js";
import { FaStethoscope } from 'react-icons/fa';
import { ClipLoader } from "react-spinners";


const MedicosConsultas = () => {
  const navigate = useNavigate();
  const [medicos, setMedicos] = useState([]);
  const [consultas, setConsultas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedico, setSelectedMedico] = useState(null);
  const [consultasMedicoModal, setConsultasMedicoModal] = useState([]);

  const [isAgendarModalOpen, setIsAgendarModalOpen] = useState(false);
  const [consultaSelecionada, setConsultaSelecionada] = useState(null);

  const API_BASE_URL = clinicaConfig.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  useEffect(() => {
    const fetchClinicData = async () => {
      try {
        setLoading(true);
        setError(null);

        const clientDomain = window.location.hostname;
        console.log('MedicosConsultas - Domínio detectado:', clientDomain);

        const headers = {
          'X-Client-Domain': clientDomain,
          'Content-Type': 'application/json'
        };

        console.log('MedicosConsultas - Headers:', headers);

        console.log('MedicosConsultas - Buscando informações da clínica...');
        const clinicInfoResponse = await fetch(`${API_BASE_URL}/public/clinic-info`, { headers });
        console.log('MedicosConsultas - Status clinic-info:', clinicInfoResponse.status);

        if (!clinicInfoResponse.ok) {
          throw new Error(`Erro ao buscar informações da clínica: ${clinicInfoResponse.status} ${clinicInfoResponse.statusText}`);
        }
        const clinicInfoData = await clinicInfoResponse.json();
        console.log('MedicosConsultas - Dados da clínica:', clinicInfoData);

        console.log('MedicosConsultas - Buscando médicos...');
        const medicsResponse = await fetch(`${API_BASE_URL}/public/medics`, { headers });
        console.log('MedicosConsultas - Status medics:', medicsResponse.status);

        if (!medicsResponse.ok) {
          throw new Error(`Erro ao buscar médicos: ${medicsResponse.status} ${medicsResponse.statusText}`);
        }
        const medicsData = await medicsResponse.json();
        console.log('MedicosConsultas - Dados dos médicos:', medicsData);

        if (medicsData.success) {
          setMedicos(medicsData.medics);
        } else {
          throw new Error(medicsData.message || 'Falha ao buscar médicos.');
        }

        console.log('MedicosConsultas - Buscando consultas disponiveis...');
        const consultasResponse = await fetch(`${API_BASE_URL}/public/consultas/disponiveis`, {
          headers,
          cache: 'no-store'
        });
        console.log('MedicosConsultas - Status consultas (disponiveis):', consultasResponse.status);

        if (!consultasResponse.ok) {
          throw new Error(`Erro ao buscar consultas disponiveis: ${consultasResponse.status} ${consultasResponse.statusText}`);
        }
        const consultasData = await consultasResponse.json();
        console.log('MedicosConsultas - Dados das consultas (disponiveis):', consultasData);

        if (consultasData.success) {
          setConsultas(consultasData.consultas);
          console.log('MedicosConsultas - Consultas disponiveis carregadas:', consultasData.consultas.length);
          console.log('MedicosConsultas - Amostra de consultas disponiveis (até 10):', consultasData.consultas.slice(0,10));
          console.log('MedicosConsultas - Amostra geral (statuses up to 20):', consultasData.consultas.map(c => c.status).slice(0,20));
        } else {
          throw new Error(consultasData.message || 'Falha ao buscar consultas.');
        }

      } catch (err) {
        console.error("MedicosConsultas - Erro ao carregar dados da clínica:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClinicData();
  }, [API_BASE_URL]);

  const compararApenasData = (data1, data2) => {
    const d1 = new Date(data1);
    const d2 = new Date(data2);

    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  const obterDataAtual = () => {
    const hoje = new Date();
    return new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 1);
  }

  const medicosComConsultas = medicos.filter(medico => {
    const consultasDoMedico = consultas.filter(consulta => {
      const dataConsulta = new Date(consulta.dataConsulta);
      const dataAtual = obterDataAtual();

      return consulta.medicId === medico.id &&
        (dataConsulta >= dataAtual || compararApenasData(dataConsulta, dataAtual));
    });
    return consultasDoMedico.length > 0;
  });

  const getConsultasPorMedico = (medicoId) => {
    return consultas
      .filter(consulta => {
        const dataConsulta = new Date(consulta.dataConsulta);
        const dataAtual = obterDataAtual();

        return consulta.medicId === medicoId &&
          (dataConsulta >= dataAtual || compararApenasData(dataConsulta, dataAtual));
      })
      .sort((a, b) => new Date(a.dataConsulta) - new Date(b.dataConsulta));
  };

  const formatarData = (dataString) => {
    const data = new Date(dataString);
    const dia = String(data.getUTCDate()).padStart(2, '0');
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
    const ano = data.getUTCFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const getDateLabel = (dataInput) => {
    if (!dataInput) return 'Sem data';
    
    // Lidar com diferentes formatos de data
    let dataString;
    if (typeof dataInput === 'object' && dataInput.$date) {
      dataString = dataInput.$date;
    } else if (dataInput instanceof Date) {
      dataString = dataInput.toISOString().split('T')[0];
    } else {
      dataString = dataInput;
    }
    
    // Criar data usando UTC para evitar problemas de timezone
    const parts = dataString.split('T')[0].split('-');
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const dataFormatada = formatarData(dataString);
    
    const sameDay = (x, y) => 
      x.getFullYear() === y.getFullYear() && 
      x.getMonth() === y.getMonth() && 
      x.getDate() === y.getDate();

    if (sameDay(d, today)) return `Hoje - ${dataFormatada}`;
    if (sameDay(d, tomorrow)) return `Amanhã - ${dataFormatada}`;
    return dataFormatada;
  };

  const handleAgendarClick = (medico) => {
    const consultasDoMedico = getConsultasPorMedico(medico.id);
    if (consultasDoMedico.length > 1) {
      setSelectedMedico(medico);
      setConsultasMedicoModal(consultasDoMedico);
      setIsModalOpen(true);
    } else if (consultasDoMedico.length === 1) {
      const consultaUnica = consultasDoMedico[0];
      setSelectedMedico(medico);
      setConsultaSelecionada(consultaUnica);
      setIsAgendarModalOpen(true);
    } else {
      alert("Não há consultas futuras disponíveis para agendamento com este médico.");
    }
  };

  const handleConsultaClick = (medico, consulta) => {
    setSelectedMedico(medico);
    setConsultaSelecionada(consulta);
    setIsAgendarModalOpen(true);
  };

  const handleModalAgendar = (medicoSelecionado, consultaSelecionada) => {
    setSelectedMedico(medicoSelecionado);
    setConsultaSelecionada(consultaSelecionada);
    setIsModalOpen(false);
    setIsAgendarModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMedico(null);
    setConsultasMedicoModal([]);
  };

  const handleCloseAgendarModal = () => {
    setIsAgendarModalOpen(false);
    setConsultaSelecionada(null);
  };

  const navegarParaTodosMedicos = () => {
    navigate('/todos-medicos');
  };

  if (loading) {
    return <section className="consultas-section"><ClipLoader size={150} color="var(--primary)" /></section>;
  }

  if (error) {
    return (
      <section className="consultas-section">
        <h2 style={{ color: 'red' }}>Erro ao carregar dados: {error}</h2>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '10px'
          }}
        >
          Tentar Novamente
        </button>
      </section>
    );
  }

  medicosComConsultas.sort((a, b) => {
    const proximaConsultaA = getConsultasPorMedico(a.id)[0];
    const proximaConsultaB = getConsultasPorMedico(b.id)[0];

    if (!proximaConsultaA) return 1;
    if (!proximaConsultaB) return -1;

    return new Date(proximaConsultaA.dataConsulta) - new Date(proximaConsultaB.dataConsulta);
  });

  const medicosVisiveis = medicosComConsultas.slice(0, 6);

  const agruparConsultasPorData = (consultasMedico) => {
    const grupos = {};

    consultasMedico.forEach(consulta => {
      const chave = getDateLabel(consulta.dataConsulta);

      if (!grupos[chave]) {
        grupos[chave] = [];
      }
      grupos[chave].push(consulta);
    });

    return grupos;
  };

  return (
    <section className="consultas-section">
      <div className="section-header">
        <h2>Futuras Consultas</h2>
        <p>Acompanhe as próximas consultas com nossos especialistas</p>
      </div>

      <Swiper
        className="medicos-swiper"
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        centeredSlides={false}
        loop={false}
        breakpoints={{
          480: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 25 },
          1280: { slidesPerView: 3, spaceBetween: 30 },
        }}
      >
        {medicosVisiveis.map((medico) => {
          const consultasAgrupadas = agruparConsultasPorData(getConsultasPorMedico(medico.id));
          
          return (
            <SwiperSlide key={medico.id}>
              <div className="medic-card">
                <div className="medic-card-header">
                  {medico.fotoUrl ? (
                    <img
                      src={medico.fotoUrl}
                      alt={`Foto de ${medico.nome}`}
                      className="medic-card-photo"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : (
                    <NoProfileIcon className="medic-card-photo" />
                  )}
                  <div className="medic-card-info">
                    <h3 className="medic-card-name">
                      {medico.genero === "Masculino" ? "Dr. " : "Dra. "}
                      {medico.nome}
                    </h3>
                    <p className="medic-card-crm">
                      {medico.especialidade === "Nutricionista" 
                        ? `CRN: ${medico.crm}` 
                        : medico.especialidade === "Biomédico" 
                        ? `CRBM: ${medico.crm}` 
                        : medico.especialidade === "Fisioterapeuta"
                        ? `Crefito: ${medico.crm}`
                        : (medico.especialidade === "Psicólogo" || medico.especialidade === "Psicóloga")
                        ? `CRP: ${medico.crm}`
                        : medico.especialidade === "Psiquiatria"
                        ? `RQE: ${medico.crm}`
                        : `CRM: ${medico.crm}`}
                    </p>
                  </div>
                </div>
                
                <div className="medic-card-specialty">
                  <FaStethoscope />
                  <span>{medico.especialidade}</span>
                </div>

                <div className="medic-consultas">
                  <h4 className="consulta-titulo">Próximas consultas</h4>
                  <div className="consultas-wrapper">
                    {Object.entries(consultasAgrupadas).map(([dataLabel, consultasGrupo], idx) => (
                      <div key={idx} className="consulta-grupo">
                        <div className="consulta-grupo-header">
                          <span className="consulta-grupo-data">{dataLabel}</span>
                          <span className="consulta-grupo-contador">
                            {consultasGrupo.length} {consultasGrupo.length === 1 ? 'Horário' : 'Horários'}
                          </span>
                        </div>
                        <div className="consulta-grupo-lista">
                          {consultasGrupo.map((consulta, index) => (
                            <div 
                              key={index} 
                              className="consulta-horario-item"
                              onClick={() => handleConsultaClick(medico, consulta)}
                              style={{ cursor: 'pointer' }}
                            >
                              <div className="consulta-horario-info">
                                <Horaicon className="consulta-icon" />
                                <span className="consulta-hora-texto">{consulta.horaConsulta}</span>
                              </div>
                              <span className="consulta-valor-texto">R${consulta.valorConsulta},00</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => handleAgendarClick(medico)}
                  className="btn-agendar-consulta"
                >
                  <i className="fab fa-whatsapp"></i>
                  <span>Agendar Consulta</span>
                </button>
              </div>
            </SwiperSlide>
          );
        })}

        <SwiperSlide key="ver-todos">
          <div className="medic-card ver-todos-card" onClick={navegarParaTodosMedicos}>
            <div className="ver-todos-content">
              <div className="ver-todos-icon">
                <i className="fas fa-user-md"></i>
              </div>
              <h3>Ver todos os médicos</h3>
              <p>Confira a lista completa de especialistas</p>
              <button className="ver-todos-btn">
                <span>Ver todos</span>
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <ConsultaSelectionModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        medico={selectedMedico}
        consultas={consultasMedicoModal}
        onAgendar={handleModalAgendar}
      />

      <AgendarConsultaModal
        isOpen={isAgendarModalOpen}
        onClose={handleCloseAgendarModal}
        consulta={consultaSelecionada}
        medico={selectedMedico}
      />
    </section>
  );
};

export default MedicosConsultas;
